
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import { HseContact } from '@/views/Project/HSE/types/hseContact'
import { getHseContacts } from '@/utils/hse'
import ProjectMixin from '@/_mixins/project'

import HseContactComponent from '@/views/Project/HSE/components/hseContact.vue'
const HseContacts = Vue.extend({
    mixins: [AppMixin, ProjectMixin],
    components: { HseContactComponent },
    props: {
        isInsert: {
            type: Boolean,
            default: false,
        },
        isDialog: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            hseContacts: [] as HseContact[],
        }
    },

    computed: {
        isPublic() {
            return this.$route.fullPath.includes('public') ? true : false
        },

        isContacts() {
            return this.$route.fullPath.includes('contacts')
        },
    },
    methods: {
        async loadHSEContacts() {
            this.hseContacts = await getHseContacts(this.currentProjectId)
        },
    },

    watch: {
        currentProjectId: {
            immediate: true,
            async handler() {
                if (!this.hasError) {
                    await this.loadHSEContacts()
                }
            },
        },
    },

    // Is temporary solution  to update hse contacts after adding new contact
    async beforeDestroy() {
        if (!this.$route.params.id) return

        if (this.isProject) {
            await this.getProject(this.$route.params.id)
        } else {
            await this.getGroup(this.$route.params.id)
        }
    },
})

export default HseContacts
